module.exports = __webpack_public_path__ + "static/media/rumble.6e4ef078.svg";